<div class="support-page">
  <!-- Support Cards -->
  <div class="support-cards">
    <div class="support-cards__grid">
      <ng-container *ngFor="let card of supportCards">
        <!-- Internal route card -->
        <a
          *ngIf="!card.comingSoon && card.route; else externalCard"
          class="support-card"
          [routerLink]="card.route"
          [fragment]="card.fragment ?? undefined"
        >
          <div class="support-card__content">
            <div class="support-card__icon-wrapper">
              <svg *ngIf="card.id === 'faq'" class="support-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              <svg *ngIf="card.id === 'user-manual'" class="support-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
              </svg>
              <svg *ngIf="card.id === 'contact-us'" class="support-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <path d="M12 8v4"></path>
                <path d="M12 16h.01"></path>
              </svg>
            </div>
            <div class="support-card__text">
              <h3 class="support-card__title">{{ card.title }}</h3>
              <p class="support-card__description">{{ card.description }}</p>
            </div>
          </div>
          <div class="support-card__arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <path d="M12 8L16 12L12 16M16 12H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </a>
        <!-- External link card (e.g. User Manual) -->
        <ng-template #externalCard>
          <a
            *ngIf="!card.comingSoon && card.href"
            class="support-card"
            [href]="card.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="support-card__content">
              <div class="support-card__icon-wrapper">
                <svg *ngIf="card.id === 'faq'" class="support-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                <svg *ngIf="card.id === 'user-manual'" class="support-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
                <svg *ngIf="card.id === 'contact-us'" class="support-card__icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <path d="M12 8v4"></path>
                  <path d="M12 16h.01"></path>
                </svg>
              </div>
              <div class="support-card__text">
                <h3 class="support-card__title">{{ card.title }}</h3>
                <p class="support-card__description">{{ card.description }}</p>
              </div>
            </div>
            <div class="support-card__arrow">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M12 8L16 12L12 16M16 12H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </a>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>


